import { Injectable, inject } from '@angular/core';
import { Constants } from '@core/app-constants';
import { Operation, OrderSeatClient, OrderSeatsCancelRequestDto } from '@core/services/apiclient';
import { HttpHandlerService } from '@core/services/http-handler.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrdersSeatsService {
  private readonly orderSeatClient = inject(OrderSeatClient);
  private readonly httpHandlerService = inject(HttpHandlerService);

  cancel(orderSeatsCancel: OrderSeatsCancelRequestDto): Observable<Operation> {
    return this.orderSeatClient
      .cancel(orderSeatsCancel, Constants.ApiVersion)
      .pipe(this.httpHandlerService.handleApiResponse<Operation>());
  }
}
